<div class="input-cell">
    <div class="input-cell-header">Edit Logo</div>
    <form [formGroup]="form" enctype="multipart/form-data">
        <input type="file" name="uploadedFile" class="file-input" (change)="uploadFile($event)" #fileUpload formControlName="uploadedFile">
        <div class="file-upload">{{fileName || "No file uploaded yet."}}
            <button nbButton status="primary" (click)="fileUpload.click()" size="tiny"><nb-icon icon="upload-outline"></nb-icon>{{fileName || "Select File."}}</button>
        </div>
    </form>
    <!-- <input type="file" class="file-input" (change)="onFileSelected($event)" #fileUpload>
    <div class="file-upload">
        <form [formGroup]="form">
            <input class="form-control file-upload" nbInput fieldSize="tiny" formControlName="uploadedFile" type="file" name="uploadedFile" id="uploadedFile" (change)="uploadFile($event)" >
        </form>
    </div> -->
</div>
<div class="input-cell">
    <div class="input-cell-header">Store Name</div>
    <div class="cell-input">
        <input name="siteName" nbInput type="text" fieldSize="small" [ngModel]="siteName" (ngModelChange)="onChangeSiteName($event)" [value]="siteName"/>
    </div>
</div>
<div class="input-cell">
    <div class="cell-input">
        <nb-toggle labelPosition="start"  (checkedChange)="onChangeShowStoreName($event)" [checked]="showStoreName">Show Store Name</nb-toggle>
    </div>
</div>
<!-- <div>Upload your logo</div>

<div class="input-content logo-navigation">
    <div class="content-cell bordered centered">
        <nb-stepper orientation="horizontal" kvActiveStepperText (stepChange)="handleStepChange($event)">
            <nb-step [label]="labelOne">
                <ng-template #labelOne>Upload your logo</ng-template>
                <div class="content-cell bordered centered">
                    <div class="option-text">Upload your logo in .png/jpg formats here.</div>
                    <div>
                        <input type="file" class="file-input" (change)="onFileSelected($event)" #fileUpload>
                        <div class="file-upload">
                            <button nbButton status="primary" (click)="fileUpload.click()" size="tiny"><nb-icon icon="upload-outline"></nb-icon>{{fileName || "No file uploaded yet."}}</button>
                        </div>
                    </div>
                </div>
                <div class="button-wrapper">
                    <button nbButton disabled nbStepperNext size="small" status="primary">prev</button>
                    <button nbButton nbStepperNext size="small" status="primary">next</button>
                </div>
            </nb-step>
            <nb-step [label]="labelTwo">
                <ng-template #labelTwo>Store Name</ng-template>
                <div class="content-cell centered">
                    <div class="option-text">Store Name</div>
                    <input type="text" nbInput fullWidth fieldSize="tiny" size="tiny" placeholder="Your Store Name Here">
                    <button nbButton size="tiny" status="primary">Update</button>   
                </div>
                <div class="button-wrapper">
                    <button nbButton disabled nbStepperNext size="small" status="primary">prev</button>
                    <button nbButton nbStepperNext size="small" status="primary">next</button>
                </div>
            </nb-step>
        </nb-stepper>
    </div>
</div> -->